<h1>{{'work_experience_order' | translate}}</h1>
<form [formGroup]="form">
  <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form"></formly-form>
</form>
<hr style="margin-top: 20px; margin-bottom: 20px;">
